import Box from '@mui/material/Box'
import iconAddLine from '../assets/icon-add-line.svg'
import iconClipboardTick from '../assets/icon-clipboard-tick.svg'
import iconPercentageCircle from '../assets/icon-percentage-circle.svg'
import iconSmartphone from '../assets/icon-smartphone.svg'
import iconUserLine from '../assets/icon-user-line.svg'

const tileIconImgSx = { width: 24, height: 24, display: 'block' } as const

/** Figma growth tile glyphs — exported from Brushfire Sensemaker List Dev Handoff (node 37:1169). */
export function GrowthMobileSignupIcon() {
  return <Box component="img" src={iconSmartphone} alt="" sx={tileIconImgSx} />
}

/** user-line + add-line composite per Figma (37:1188–37:1190). */
export function GrowthNewSensemakerSignupIcon() {
  return (
    <Box sx={{ position: 'absolute', inset: 0 }}>
      <Box
        component="img"
        src={iconUserLine}
        alt=""
        sx={{ position: 'absolute', left: '10px', top: '14px', width: 19, height: 19, display: 'block' }}
      />
      <Box
        component="img"
        src={iconAddLine}
        alt=""
        sx={{ position: 'absolute', left: '22px', top: '15px', width: 15, height: 15, display: 'block' }}
      />
    </Box>
  )
}

export function GrowthConversionRateIcon() {
  return <Box component="img" src={iconPercentageCircle} alt="" sx={tileIconImgSx} />
}

export function GrowthProfileCompletionIcon() {
  return <Box component="img" src={iconClipboardTick} alt="" sx={tileIconImgSx} />
}
